import { useState } from "react";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import { useBootstrap } from "@/features/bootstrap";
import { DisplayNameButton } from "../components/DisplayNameButton";
import { ROLES } from "@/features/router/roles";

const ROLE_LABELS = {
  [ROLES.STUDENT]: "Student",
  [ROLES.TEACHER]: "Teacher",
  [ROLES.ADMIN]: "Administrator",
  [ROLES.SUPERADMIN]: "Superadmin",
  [ROLES.TECH]: "1-2-3 Wellness™ Leader",
};

export function AccountSection() {
  const { data: user } = useBootstrap();
  const [showEmailPopover, setShowEmailPopover] = useState(false);

  if (!user) {
    return null;
  }

  return (
    <div className="flex flex-row items-start gap-3 w-full">
      {user.photoURL ? (
        <img
          className="h-20 w-auto rounded"
          alt="Profile"
          src={user.photoURL}
          referrerPolicy="no-referrer"
          onError={(e) => (e.currentTarget.style.display = "none")}
        />
      ) : (
        <SentimentSatisfiedAltIcon style={{ fontSize: 80, color: "#4cc68d" }} />
      )}

      <div className="flex flex-col gap-2 w-full">
        <div className="flex flex-row items-center justify-between">
          <div className="text-[16px] flex items-center gap-1">
            <span className="font-bold">Name:</span>
            {user.displayName}
          </div>
          {user.role !== ROLES.STUDENT && (
            <div className="hidden sm:block">
              <DisplayNameButton />
            </div>
          )}
        </div>
        <div className="text-[16px] gap-1 flex items-center relative">
          <span className="font-bold">Email:</span>
          <button
            type="button"
            onClick={() => setShowEmailPopover(true)}
            className="inline-block truncate max-w-[42vw] text-left sm:hidden"
          >
            {user.email}
          </button>
          <span className="hidden sm:inline break-all">{user.email}</span>
          {showEmailPopover && (
            <>
              <div
                className="fixed inset-0 z-10 sm:hidden"
                onClick={() => setShowEmailPopover(false)}
              />
              <div className="fixed z-10 left-20 top-48 max-w-[90vw] bg-white text-[15px] px-2 py-1 rounded shado-md border border-[#DDDDDD] sm:hidden">
                <span className="break-all">{user.email}</span>
              </div>
            </>
          )}
        </div>
        <div className="text-[16px] gap-1 flex flex-row">
          <span className="font-bold">Role:</span>
          <div>{ROLE_LABELS[user.role] ?? user.role}</div>
        </div>
        {user.role !== ROLES.STUDENT && (
          <div className="sm:hidden">
            <DisplayNameButton />
          </div>
        )}
      </div>
    </div>
  );
}
